import React from 'react';
import { Navigate } from 'react-router-dom';
import Layout from '../Layout';
import { useAuth } from '../../context/auth';
import { routes } from '../../constants';
import { useGetUserSurvey } from '../../api-calls/survey.queries';
import { surveyTypes } from '../../constants/data-types';

interface RouteWrapperProps {
  children: React.ReactNode;
  layout: string;
  isPrivate?: boolean;
  allowedRoles?: string[];
  hideNavbar?: boolean;
  headerType?: 'default' | 'survey';
  hideHeader?: boolean;
  requireSurveyAccess?: boolean;
}

const RouteWrapper: React.FC<RouteWrapperProps> = ({
  children,
  layout,
  isPrivate = false,
  headerType = 'default',
  hideHeader = false,
  hideNavbar = false,
  allowedRoles = [],
  requireSurveyAccess = false,
}) => {
  const { token, loading, refreshing, user } = useAuth();
  const salesforceContactId = user ? user.salesforceContactId : '';

  const { data: surveyData, isLoading: surveyLoading, error: surveyError } = useGetUserSurvey({
    salesforceContactId,
    enabled: requireSurveyAccess && !!salesforceContactId
  });

  if (isPrivate) {
    if (refreshing || loading || (requireSurveyAccess && surveyLoading)) {
      return <div>Loading...</div>;
    } else if (!token || !user) {
      return <Navigate to={routes.LOGIN} />;
    }

    if (allowedRoles.length && !allowedRoles.includes(user.role)) {
      return <Navigate to={routes.UNAUTHORISED} />;
    }

    if (requireSurveyAccess) {
      const isSurveyDataValid = surveyData && typeof surveyData === 'object';
      const isSurveyOpen = isSurveyDataValid && [surveyTypes.OPEN, surveyTypes.IN_PROGRESS].includes(surveyData.status);
      if (!isSurveyOpen || surveyError) {
        return <Navigate to={routes.HOME} />;
      }
    }
  }

  return (
    <Layout
      layout={layout}
      headerType={headerType}
      hideHeader={hideHeader}
      hideNavbar={hideNavbar}
    >
      {children}
    </Layout>
  );
};

export default RouteWrapper;
